'use strict';
var ApplicationConstants = require('../constants/ApplicationConstants');

var FormKeys = ApplicationConstants.FormKeys;
var AccountTypeCodes = ApplicationConstants.AccountTypeCodes;
var InvestorLimits = ApplicationConstants.InvestorLimits;

module.exports = {
    checkIfJointAccount(accountType) {
        return accountType === AccountTypeCodes.JOINT;
    },

    getInvestorLimit: function (formKey) {
        var investorLimit = 0;
        switch (formKey) {
            case FormKeys.JOINT_INVESTMENT:
                investorLimit = InvestorLimits.JOINT_INVESTMENT;
                break;
            case FormKeys.JOINT_CHALLENGER:
            case FormKeys.JOINT_COMMINSURE:
            case FormKeys.COMPANY_INVESTMENT:
            case FormKeys.PARTNERSHIP_INVESTMENT:
                investorLimit = InvestorLimits.JOINT_ANNUITIES;
                break;
            case FormKeys.TRUST_CHALLENGER:
            case FormKeys.TRUST_COMMINSURE:
            case FormKeys.SMSF_CHALLENGER:
            case FormKeys.SMSF_COMMINSURE:
                investorLimit = InvestorLimits.TRUST_ANNUITIES;
                break;
            case FormKeys.SMSF_INVESTMENT:
                investorLimit = InvestorLimits.SMSF_INVESTMENT;
                break;
            case FormKeys.TRUST_INVESTMENT:
                investorLimit = InvestorLimits.TRUST_INVESTMENT;
                break;
            default:
                investorLimit = InvestorLimits.DEFAULT;
                break;
        }
        return investorLimit;
    }
};



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/AccountTypes.js